import { OFFER_TYPES } from "../constants/offerTypes";
import { TITLE_SOURCES } from "../constants/titleSources";
import { findPortalDataEntity } from "./portalData";

const floatKeys = [
  "cashbackAmount",
  "connectionFee",
  "dataSpeedDown",
  "dataSpeedUp",
  "monthlyFee",
  "phoneMonthlyFee",
  "price",
  "servicesMonthlyFee",
  "shippingCosts",
  "standardMonthlyFee",
  "standardServicesMonthlyFee",
  "tco",
  "tcoPerMonth"
];

const integerKeys = [
  "contractTermInMonths",
  "dataCredits",
  "dataSpeedGen",
  "promotionDataCredits",
  "promotionTerm",
  "promotionVoiceCredits",
  "smsCredits",
  "voiceCredits"
];

function enrichOfferData(clientConfig, offerType, portalObjects, portalData) {
  let newPortalObjects = [];
  const withDetails = portalObjectsWithDetails(portalObjects[0]);

  for (const portalObject of portalObjects) {
    try {
      let newPortalObject = { ...portalObject };

      for (const key of Object.keys(newPortalObject)) {
        if (portalObject[key] != null) {
          if (floatKeys.indexOf(key) >= 0) {
            newPortalObject[key] = parseFloat(portalObject[key]);
          } else if (integerKeys.indexOf(key) >= 0) {
            newPortalObject[key] = parseInt(portalObject[key], 10);
          }

          if (!withDetails) {
            if (key === "brand") {
              const brand = findPortalDataEntity(
                portalData,
                "brand",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                image80x: brand.image80x,
                name: brand.name
              };
            } else if (key === "offerExtras") {
              newPortalObject.offerExtras = [];

              if (Array.isArray(portalObject[key])) {
                for (const portalOfferExtra of portalObject[key]) {
                  const offerExtra = findPortalDataEntity(
                    portalData,
                    "offerExtra",
                    portalOfferExtra.id
                  );
                  const newOfferExtra = {
                    id: portalOfferExtra.id,
                    frontendOfferText: offerExtra.frontendOfferText,
                    showNormalOnFrontend: offerExtra.showNormalOnFrontend,
                    showStrongOnFrontend: offerExtra.showStrongOnFrontend
                  };

                  newPortalObject.offerExtras.push(newOfferExtra);
                }
              }
            } else if (key === "phone") {
              const phone = findPortalDataEntity(
                portalData,
                "phone",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                simCount: phone.simCount,
                memory: phone.memory,
                name: phone.name,
                image64x64: phone.image64x64,
                image136x136: phone.image136x136,
                phoneVariants: phone.phoneVariants
              };
            } else if (key === "phoneOperatingSystem") {
              const phoneOperatingSystem = findPortalDataEntity(
                portalData,
                "phoneOperatingSystem",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                name: phoneOperatingSystem.name
              };
            } else if (key === "phoneState") {
              const phoneState = findPortalDataEntity(
                portalData,
                "phoneState",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                name: phoneState.name
              };
            } else if (key === "phoneVariant") {
              const phoneVariant = findPortalDataEntity(
                portalData,
                "phoneVariant",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                name: phoneVariant.name,
                primaryColor: phoneVariant.primaryColor,
                secondaryColor: phoneVariant.secondaryColor
              };
            } else if (key === "phoneVariants") {
              newPortalObject.phoneVariants = [];
              const phone = findPortalDataEntity(
                portalData,
                "phone",
                portalObject.phone.id
              );
              for (const phoneVariantBase of phone.phoneVariants) {
                const idsKey = `${offerType}Ids`;
                if (
                  portalData.entities.phoneVariants[idsKey].indexOf(
                    phoneVariantBase.id
                  ) >= 0
                ) {
                  const phoneVariant = findPortalDataEntity(
                    portalData,
                    "phoneVariant",
                    phoneVariantBase.id
                  );
                  const newPhoneVariant = {
                    ...phoneVariantBase,
                    name: phoneVariant.name,
                    primaryColor: phoneVariant.primaryColor,
                    secondaryColor: phoneVariant.secondaryColor
                  };

                  newPortalObject.phoneVariants.push(newPhoneVariant);
                }
              }
            } else if (key === "provider") {
              const provider = findPortalDataEntity(
                portalData,
                "provider",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                name: provider.name,
                image160x: provider.image160x
              };
            } else if (key === "shop") {
              const shop = findPortalDataEntity(
                portalData,
                "shop",
                portalObject[key].id
              );
              newPortalObject[key] = {
                ...newPortalObject[key],
                name: shop.name,
                image75x: shop.image75x
              };
            } else if (key === "shops") {
              newPortalObject[key] = [];
              for (const portalObjectShop of portalObject[key]) {
                const shop = findPortalDataEntity(
                  portalData,
                  "shop",
                  portalObjectShop.id
                );

                let offerExtras = [];
                if (Array.isArray(portalObjectShop.offerExtras)) {
                  for (const portalOfferExtra of portalObjectShop.offerExtras) {
                    const offerExtra = findPortalDataEntity(
                      portalData,
                      "offerExtra",
                      portalOfferExtra.id
                    );
                    const newOfferExtra = {
                      id: portalOfferExtra.id,
                      frontendOfferText: offerExtra.frontendOfferText,
                      showNormalOnFrontend: offerExtra.showNormalOnFrontend,
                      showStrongOnFrontend: offerExtra.showStrongOnFrontend
                    };

                    offerExtras.push(newOfferExtra);
                  }
                }

                newPortalObject[key].push({
                  ...portalObjectShop,
                  name: shop.name,
                  offerExtras: offerExtras,
                  image75x: shop.image75x
                });
              }
            }
          }
        }
      }

      newPortalObject.titleSource = getTitleSource(offerType);

      newPortalObjects.push(newPortalObject);
    } catch (e) {}
  }

  return newPortalObjects;
}

function portalObjectsWithDetails(offerData) {
  try {
    return (
      (offerData.brand && offerData.brand.name != null) ||
      (offerData.provider && offerData.provider.name != null)
    );
  } catch (e) {
    return false;
  }
}

function getTitleSource(offerType) {
  if (offerType === OFFER_TYPES.phoneOffer) {
    return TITLE_SOURCES.phone;
  } else if (offerType === OFFER_TYPES.simOnly) {
    return TITLE_SOURCES.provider;
  } else {
    return TITLE_SOURCES.phone;
  }
}

function getType(offer) {
  if (offer.isSimOnly) {
    return OFFER_TYPES.simOnly;
  } else if (offer.contractTermInMonths) {
    return OFFER_TYPES.proposition;
  } else {
    return OFFER_TYPES.phoneOffer;
  }
}

function getOfferData(offerDataType, portalData) {
  if (offerDataType === "phoneOffer") {
    return portalData.entities.phoneOffers;
  } else if (offerDataType === "proposition") {
    return portalData.entities.propositions;
  } else if (offerDataType === "simOnly") {
    return portalData.entities.simOnlyOffers;
  } else if (offerDataType === "sponsoredPosition") {
    return portalData.entities.sponsoredPositions;
  }
}

const offerData = (clientConfig, offerType, offerDataType, portalData) => {
  const offerData = getOfferData(offerDataType, portalData);

  let offers = enrichOfferData(clientConfig, offerType, offerData, portalData);

  offers = offers.map(offer => {
    offer.isSponsored = offerDataType === "sponsoredPosition";
    offer.type = getType(offer);
    return offer;
  });

  return offers;
};

export { offerData };
